const NotFound = () => {
    return (
        <div style={{ padding: 40 }}>
            <h1>404 - Page Not Found</h1>
        </div>
    );
};

export default NotFound;
